
import { Component, Input } from "@angular/core";
import { publicHelpers } from 'globals/helpers/public-helpers';
import { IconComponent } from "./icon.component";
import { CommonModule } from "@angular/common";

@Component({
    selector: 'made-with-joi',
    template: `
<icon 
  icon="made_with_joi" 
  (click)="!showLink ? null : helpers.openInNewTab(link)" 
  [ngClass]="{ showLink: showLink }" 
  class="madeWithJoi"
></icon>`,
    styles: [`
.madeWithJoi { width: 50px; height: 50px; color: rgba(0,0,0,.15); margin: 10px auto 0px auto; display: flex; }
.showLink { cursor: pointer; }
 `],
    standalone: true,
    imports: [IconComponent, CommonModule],
})
export class MadeWithJoiComponent {
  helpers = publicHelpers
  @Input() showLink = true
  @Input() link = "https://joi.events?utm_campaign=Made%20with%20Joi%20icon&utm_source=Published%20Joi%20pages" // hubspot link
}

